import { render } from "./PropertyStatement.vue?vue&type=template&id=4ed145ca"
import script from "./PropertyStatement.vue?vue&type=script&lang=js"
export * from "./PropertyStatement.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__